import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SubridersComponent } from './subriders/subriders.component';


const routes: Routes = [{
  path: '',
  component: SubridersComponent,
  data: { title: null }
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubridersRoutingModule { }
